import { Field, useField } from "formik";

export default function TextArea({
  label,
  inputClass,
  containerClass,
  errorClass,
  ...props
}) {
  const [field, meta] = useField(props);

  return (
    <div className={`${containerClass || ""}`}>
      <label className="block mb-2 text-sm font-medium text-gray-800 dark:text-white">
        {label}
      </label>
      <textarea
        {...field}
        {...props}
        className={`min-h-10 bg-white/50  border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-800 dark:focus:ring-blue-500 dark:focus:border-blue-500 ${inputClass}`}
      />
      {meta.touched && meta.error ? (
        <p
          className={`text-sm my-4 text-red-900 dark:text-red-400 ${errorClass}`}
        >
          {meta.error}
        </p>
      ) : null}
    </div>
  );
}
